import { createInterfaceToken } from '@bmai/shared';
import type {
    CategoryAssistPlan,
    CategoryAssistRequest,
    SubcategoryGenerationPlan,
    SubcategoryGenerationRequest,
} from '@/shared/assist/CategoryAssistContract';

/**
 * Turns a refinement ask into staged taxonomy-change suggestions. The
 * implementation calls the bmai-web BFF (`/_assist/categories`), which queries
 * telemetry OLAP for over-assigned categories and topic/prompt evidence, then
 * runs the suggestion through the generic telemetry structured-LLM endpoint —
 * no LLM SDK or model knowledge lives in the browser.
 */
export interface ICategorySuggestionEngine {
    suggest(request: CategoryAssistRequest): Promise<CategoryAssistPlan>;
    /** Bulk usage-subcategory generation for one chunk of leaf org nodes (`/_assist/categories/subcategories`). */
    generateSubcategories(request: SubcategoryGenerationRequest): Promise<SubcategoryGenerationPlan>;
}

export const ICategorySuggestionEngineToken = createInterfaceToken<ICategorySuggestionEngine>('ICategorySuggestionEngine');
